<span [ngClass]="'bg-' + {color}" class="rounded-full flex items-center justify-center font-body"></span>